import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import MusorContent from './MusorContent';
import TulajdonsagContent from './TulajdonsagContent';
import KenyelmiDijContent from './KenyelmiDijContent';

import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../EsemenyekTooltips';
import Service from './services';


class MusorBase extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: undefined,
      isMusorTabActive: false,
      isTulajdonsagTabActive: false,
      isKenyelmiDijActive: false,
      kenyelmiDijParam: false,
    };
  }

  componentDidMount() {
    Service.getKenyelmiDijParam((err, res) => {
      if (!err) {
        this.setState({ kenyelmiDijParam: res[0] == true });
      }
    });
    if (this.props.globals.hasRole(['MUSOR_MUSOR'])) {
      this.toggle('1');
    } else if (this.props.globals.hasRole(['MUSOR_TULAJDONSAG'])) {
      this.toggle('2');
    } else if (this.props.globals.hasRole(['MUSOR_MUSOR'])) {
      this.toggle('3');
    }
  }

  toggle(tab) {
    this.setState({
      isMusorTabActive: tab === '1',
      isTulajdonsagTabActive: tab === '2',
      isKenyelmiDijActive: tab === '3',
    });
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  render() {
    let cardStyle = {
      padding: 10
    };

    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              {'Műsorok'}
            </div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <Nav tabs>
                  {this.props.globals.hasRole(['MUSOR_MUSOR']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '1' })}
                        onClick={() => {
                          this.toggle('1');
                          // if (this.child1) this.child1.updateTable();
                        }}
                      >
                        {'Műsor'}
                        <CustomTooltip text={getTooltip('musorok')} id="musorokTT" />
                      </NavLink>
                    </NavItem>
                  )}
                  {this.props.globals.hasRole(['MUSOR_TULAJDONSAG']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '2' })}
                        onClick={() => {
                          this.toggle('2');
                          // if (this.child2) this.child2.updateTable();
                        }}
                      >
                        {'Tulajdonság'}
                        <CustomTooltip text={getTooltip('tulajdonsagok')} id="tulajdonsagokTT" />
                      </NavLink>
                    </NavItem>
                  )}
                  {this.props.globals.hasRole(['MUSOR_MUSOR']) && this.state.kenyelmiDijParam && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '3' })}
                        onClick={() => {
                          this.toggle('3');
                          // if (this.child3) this.child3.updateTable();
                        }}
                      >
                        {'Kényelmi díj'}
                        <CustomTooltip text={getTooltip('kenyelmidij')} id="kenyelmidijTT" />
                      </NavLink>
                    </NavItem>
                  )}
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  {this.props.globals.hasRole(['MUSOR_MUSOR']) && (
                    <TabPane tabId="1">
                      <MusorContent
                        {...this.props}
                        globals={this.props.globals}
                        active={this.state.isMusorTabActive}
                        ref={(instance) => { this.child1 = instance; }}
                      />
                    </TabPane> 
                  )}
                  {this.props.globals.hasRole(['MUSOR_TULAJDONSAG']) && (
                    <TabPane tabId="2">
                      <TulajdonsagContent
                        {...this.props}
                        globals={this.props.globals}
                        active={this.state.isTulajdonsagTabActive}
                        ref={(instance) => { this.child2 = instance; }}
                      />
                    </TabPane>
                  )}
                  {this.props.globals.hasRole(['MUSOR_MUSOR']) && this.state.kenyelmiDijParam && (
                    <TabPane tabId="3">
                      <KenyelmiDijContent
                        {...this.props}
                        globals={this.props.globals}
                        active={this.state.isKenyelmiDijActive}
                        ref={(instance) => { this.child3 = instance; }}
                      />
                    </TabPane>
                  )}
                </TabContent>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

MusorBase.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};

export default MusorBase;
